export const NAME = 'pickers_users';